import $ from 'jquery';

import { Functions } from '../helpers';

export class Dropdown {

	constructor( App ) {
		Dropdown.App      = App;
		Dropdown.UI       = App.PwnUI;
		Dropdown.settings = App.settings;
		this.$element = $( '.js-pwn-dropdown' );
		this.initialize();
	};

	initialize() {
	    if ( ! this.$element.length ) return;

	    var that = this;

	    // Scrollbar support
	    if ( $.fn.fsScrollbar !== undefined ) {
	    	$.fn.fsScrollbar = undefined;
	    }

	    Formstone.isMobile = false;

	    this.$element.dropdown();
	 //    this.$element.dropdown("defaults", {
		// 	bottomEdge: 0,
		// 	cover: false,
		// 	customClass: "",
		// 	label: "",
		// 	external: false,
		// 	links: false,
		// 	mobile: false, // TODO: deprecated
		// 	native: false,
		// 	theme: "fs-light",
		// 	trim: 0,
		// 	selectMultiple: false
		// });

	    this.$element.closest( '.fs-dropdown' ).on( 'close.dropdown', function() {
	    	var value = $( 'option:selected', $( this ).find( that.$element ) ).val();

	    	if ( '' !== value ) {
	    		$( this )
	    			.find( '.fs-dropdown-selected' )
	    		.addClass( 'fs-dropdown-isfilled' );
	    	}
	    	else {
	    		$( this )
	    			.find( '.fs-dropdown-selected' )
	    		.removeClass( 'fs-dropdown-isfilled' );
	    	}
	    } );

	    this.$element.on( 'change', function() {
	    	var value = $( 'option:selected', this ).val();

	    	if ( '' !== value ) {
	    		$( this ).closest( '.fs-dropdown' )
	    			.find( '.fs-dropdown-selected' )
	    		.addClass( 'fs-dropdown-isfilled' );
	    	}
	    	else {
	    		$( this ).closest( '.fs-dropdown' )
	    			.find( '.fs-dropdown-selected' )
	    		.removeClass( 'fs-dropdown-isfilled' );
	    	}
	    } );
	};
}
